export const MESAS_LOADING = 'MESAS_LOADING'
export const MESAS_LIST = 'MESAS_LIST'
export const MESA_SELECTED = 'MESA_SELECTED'
export const CLIENTES_LOADING = 'CLIENTES_LOADING'
export const SET_MESA = 'SET_MESA'
export const ITEMS_LISTA = 'ITEMS_LISTA'
export const CLIENTES_MESA_LISTA = 'CLIENTES_MESA_LISTA'
export const CLIENTE_MESA_SELECIONADO = 'CLIENTE_MESA_SELECIONADO'
export const LISTA_PROD = 'LISTA_PROD'
export const CARDAPIO = 'CARDAPIO'
export const SET_PROD_PAGE = 'SET_PROD_PAGE'
export const SET_PROD_PERPAGE = 'SET_PROD_PERPAGE'
export const SET_PROD_TOTAL = 'SET_PROD_TOTAL'
export const SET_PESQ_CLI = 'SET_PESQ_CLI'
export const SET_DIALOG = 'SET_DIALOG'
export const CLIENTES_LIST = 'CLIENTES_LIST'
export const SET_CLI_COMANDA_SEL = 'SET_CLI_COMANDA_SEL'
export const LIST_CATEGORIAS = 'LIST_CATEGORIAS'
export const CARDAPIO_PDV = 'CARDAPIO_PDV'
export const CLI_PDV = 'CLI_PDV'
export const LIST_PEDIDOS_PDV = 'LIST_PEDIDOS_PDV'
export const CLI_PDV_CPF = 'CLI_PDV_CPF'
export const RESUMO_PED_PDV = 'RESUMO_PED_PDV'
export const SET_PED_PDV = 'SET_PED_PDV'
export const PEDIDO_PDV_EFETIVADO = 'PEDIDO_PDV_EFETIVADO'
export const PEDIDO_PDV_EDIT = 'PEDIDO_PDV_EDIT'